// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/utils/referralOpennessApi.js
//
// « Je peux aider » (lot 3, L3a) : un seul appel, PATCH /api/members/referral-openness. L'identité vient du jeton
// (jamais de l'interface), la valeur est un booléen strict, l'opération est idempotente et ne notifie personne.

import { patch } from './apiClient'

/** @param {boolean} enabled @returns {Promise<{referral_openness: boolean}>} */
export const setReferralOpenness = (enabled) =>
  patch('/members/referral-openness', { enabled: enabled === true })
